module.exports = __webpack_public_path__ + "img/lottery_600.bcd44ef4.png";